export type CustomAction = {
  accountId: number;
  customuserId: number;
  description: string;
  extensionType: 'CODE' | 'REQUEST';
  id: number;
  isPublic: boolean; // inferred - when visibility is P and status is P
  name: string;
  selectedApi: string;
  status: ActionStatus;
  visibility: 'U' | 'A' | 'P'; // U - User, A - Account, P - Public
};

export enum ActionStatus {
  DRAFT = 'D',
  PENDING_REVIEW = 'R',
  PUBLISHED = 'P',
}
